import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ImageTypeEnum,ImageTypeEnumPath } from 'src/app/shared/enums/image-type';
import { Helper } from '../../utils/helper';

@Component({
  selector: 'app-img-list',
  templateUrl: './img-list.component.html',
  styleUrls: ['./img-list.component.css']
})
export class ImgListComponent implements OnInit {
  readonly rootUrl = environment.rootUrl;
  imgeList: ThumbnailImg[] = [];
  constructor(
    private toast: ToastrService,
    public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.imgeList = this.imgeList.filter((o) => {
      return (
        o.imageType == ImageTypeEnum.DO ? o.icon = ImageTypeEnumPath.SIGNATUREPath : ImageTypeEnumPath.DefualtPath,
        o.imageType == ImageTypeEnum.POD ? o.icon = ImageTypeEnumPath.SIGNATUREPath : ImageTypeEnumPath.DefualtPath,
        o.imageType == ImageTypeEnum.SIGNATURE ? o.icon = ImageTypeEnumPath.SIGNATUREPath : ImageTypeEnumPath.DefualtPath,
        o.imageType == ImageTypeEnum.UNDEL ? o.icon = ImageTypeEnumPath.SIGNATUREPath : ImageTypeEnumPath.DefualtPath
      )
    })
  }

  onView(img: ThumbnailImg) {
    if (Helper.isEmpty(img.imagePath)) {
      return this.toast.error("Image path not found");
    }
    const fullPath = `${this.rootUrl}/uploads/${img.imagePath}`;
    window.open(fullPath, '_blank');
    return;
  }
}
export interface ThumbnailImg {
  id?: string;
  imagePath?: string;
  imageType?: string;
  icon?: string;
}
